import { X } from "lucide-react";

/* Barre d'actions groupées. Elle n'apparaît qu'avec une sélection, et propose
   d'étendre la sélection à tous les éléments filtrés — en le disant clairement,
   parce que l'écart entre « cette page » et « tout le filtre » est la source
   d'erreur classique des consoles d'administration. */
export default function BulkBar({
  count = 0,
  total = 0,
  allMatching = false,
  onSelectAllMatching,
  onClear,
  actions = [],
  busy = false,
}) {
  if (!count) return null;
  const canExtend = !allMatching && total > count && Boolean(onSelectAllMatching);

  return (
    <div className="adm-bulk" role="region" aria-label="Actions groupées" data-testid="bulk-bar">
      <span className="adm-bulk-count">
        {allMatching ? `${total} élément${total > 1 ? "s" : ""} sélectionnés (filtre entier)` : `${count} sélectionné${count > 1 ? "s" : ""}`}
      </span>
      {canExtend && (
        <button type="button" className="adm-bulk-all" onClick={onSelectAllMatching} data-testid="bulk-select-all">
          Sélectionner les {total} éléments du filtre
        </button>
      )}
      <span className="adm-bulk-sep" aria-hidden="true" />
      {actions.map(action => (
        <button
          key={action.id}
          type="button"
          className={`adm-bulk-act${action.tone === "danger" ? " is-danger" : ""}`}
          onClick={() => action.onRun({ allMatching, count })}
          disabled={busy || action.disabled}
          title={action.disabledReason}
          data-testid={`bulk-${action.id}`}
        >
          {action.icon && <action.icon size={13} />}{action.label}
        </button>
      ))}
      <button type="button" className="adm-bulk-act" onClick={onClear} aria-label="Vider la sélection" data-testid="bulk-clear">
        <X size={13} />
      </button>
    </div>
  );
}
